/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  StaticPageContentService,
  IStaticPageContentMethods,
  IKanbaListMethods,
  KanbanListService,
  ICreateTemplateMethods,
  CreateTemplateService,
  EvidenceKanbanListService,
  IEvidenceKanbaListMethods,
  PreviewTemplateService,
  IPreviewTemplateMethods,
  ISubmitTemplateMethods,
  SubmitTemplateService,
} from "./components";

export type CreatePortfolioTemplatePageAgent = IStaticPageContentMethods &
  IKanbaListMethods &
  ICreateTemplateMethods &
  IEvidenceKanbaListMethods &
  ISubmitTemplateMethods &
  IPreviewTemplateMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new KanbanListService(),
    new CreateTemplateService(),
    new EvidenceKanbanListService(),
    new PreviewTemplateService(),
    new SubmitTemplateService(),
  ];
};

export const getAgent = () => {
  return createAgent<CreatePortfolioTemplatePageAgent>({
    plugins: getPlugins(),
  });
};
